/* Royal Hair – homepage interactions (rails, reveal, quick add) */
(function () {
  'use strict';
  /* 2026-10-22: run once per page. The file is included by several sections and the Theme Editor re-executes it on every section reload; listeners/observers must not accumulate. */
  if (window.__rhHomeJs) return; window.__rhHomeJs = true;
  var root = document.documentElement;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!designMode && !reduce) root.classList.add('rh-js');

  var io = null;
  if ('IntersectionObserver' in window && !designMode && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function initReveal(scope) {
    var els = scope.querySelectorAll('.rh-reveal:not(.is-in)');
    els.forEach(function (el, i) {
      if (!io) { el.classList.add('is-in'); return; }
      el.style.transitionDelay = Math.min(i % 6, 5) * 70 + 'ms';
      io.observe(el);
    });
  }

  function initRail(wrap) {
    if (wrap.__rhRail) return;
    wrap.__rhRail = true;
    var rail = wrap.querySelector('[data-rh-rail]');
    if (!rail) return;
    var prev = wrap.querySelector('[data-rh-prev]');
    var next = wrap.querySelector('[data-rh-next]');
    var bar = wrap.querySelector('[data-rh-bar]');
    function step() {
      var item = rail.firstElementChild;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      var ratio = max > 0 ? rail.scrollLeft / max : 0;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (bar) {
        var vis = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
        bar.style.width = Math.max(vis * 100, 8) + '%';
        bar.style.transform = 'translateX(' + ratio * (100 / Math.max(vis, 0.08) - 100) + '%)';
        bar.parentElement.style.visibility = max > 2 ? 'visible' : 'hidden';
      }
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initQuickAdd(scope) {
    scope.querySelectorAll('form[data-rh-quick-add]').forEach(function (form) {
      if (form.__rhQa) return;
      form.__rhQa = true;
      form.addEventListener('submit', function (evt) {
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) return; // native POST fallback
        evt.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var fd = new FormData(form);
        if (typeof cart.getSectionsToRender === 'function') {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) {
              if (btn) { btn.textContent = res.description || res.message || 'Unavailable'; setTimeout(function () { btn.innerHTML = label; }, 2600); }
              return;
            }
            cart.renderContents(res);
            if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rh-rail-wrap]').forEach(initRail);
    initReveal(scope);
    initQuickAdd(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* Card hover media (image 2 / video) lives in rh-card-media.js, loaded once in the layout. */
})();
